import {
    ADD_CANCEL_REASON_START,
    ADD_CANCEL_REASON_SUCCESS,
    ADD_CANCEL_REASON_ERROR
} from '../../../constants/index';
import history from '../../../history';
import { setLoaderStart, setLoaderComplete } from '../../loader/loader';
import { updateMutation } from '../../../lib/graphql';
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';

export const addCancelReason = (values) => {

    return async (dispatch, getState, { client }) => {

        try {
            values.isActive = Number(values.isActive);

            dispatch({
                type: ADD_CANCEL_REASON_START
            })

            dispatch(setLoaderStart('AddCancellation'));
            const { data } = await client.mutate({
                mutation: updateMutation,
                variables: {
                    id: values?.id,
                    reason: values?.reason,
                    userType: values?.userType,
                    isActive: values?.isActive
                }
            })

            if (data?.updateCancelReason?.status === 200) {
                history.push('/siteadmin/cancel-reasons');
                showToaster({ messageId: 'addCancelSuccess', requestContent: { id: values && values.id }, toasterType: 'success' });

                await dispatch({
                    type: ADD_CANCEL_REASON_SUCCESS,
                });
            } else {
                showToaster({ messageId: 'errorMessage', requestContent: { content: data?.updateCancelReason?.errorMessage }, toasterType: 'error' });

                await dispatch({
                    type: ADD_CANCEL_REASON_ERROR,
                });
            }
            dispatch(setLoaderComplete('AddCancellation'));

        } catch (err) {
            showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
            dispatch({ type: ADD_CANCEL_REASON_ERROR })
        }
    }
}